export const DSA_TYPES = [
  "Arrays",
  "Strings",
  "Linked List",
  "Stacks",
  "Queues",
  "Trees",
  "Graphs",
  "Hashing",
  "Sorting",
  "Searching",
  "Recursion",
  "Backtracking",
  "Dynamic Programming",
  "Greedy",
  "Bit Manipulation",
  "Two Pointers",
  "Sliding Window",
  "Heap / Priority Queue",
  "Math",
];

// ── Salesforce Apex track ─────────────────────────────────────────────────────
// Must stay in sync with BackEnd/app/constants/apex.py (the server validates all of it).
export const APEX_TRACK = "apex";
export const APEX_LANGUAGE = "Apex";

export const APEX_TOPICS = [
  "Apex Fundamentals",
  "Collections",
  "SOQL / SOSL",
  "DML & Database Methods",
  "Triggers",
  "Bulkification",
  "Governor Limits",
  "Order of Execution",
  "Async Apex",
  "Test Classes",
  "Security & Sharing",
];

export const APEX_DIFFICULTIES = ["Easy", "Medium", "Hard"];

// Pre-filled into the custom-problem rubric editor; weights add up to 100.
export const DEFAULT_APEX_RUBRIC = [
  { id: "correctness", name: "Correctness & requirement coverage", description: "Solves every requirement in the problem statement, including edge cases (null/empty input, single vs many records).", weight: 30 },
  { id: "bulkification", name: "Bulkification", description: "Handles collections of records, not one record at a time. Uses Sets/Maps to avoid nested loops.", weight: 20 },
  { id: "governor_limits", name: "Governor-limit safety", description: "No SOQL or DML inside loops, queries are selective, no unnecessary queries or DML statements.", weight: 20 },
  { id: "best_practices", name: "Apex best practices & readability", description: "Clear naming, separation of concerns (e.g. trigger handler pattern), no hardcoded IDs, sharing keywords used deliberately.", weight: 10 },
  { id: "error_handling", name: "Error handling", description: "Uses try/catch or Database methods with partial success where appropriate, and surfaces errors meaningfully.", weight: 10 },
  { id: "test_quality", name: "Test coverage & quality", description: "If tests are part of the task: @isTest, test data setup, bulk scenario, meaningful System.assert calls. Otherwise judge testability of the code.", weight: 10 },
];

export const APEX_STARTER_TEMPLATE = "public with sharing class MyService {\n    // TODO: implement\n}\n";
